/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:browser
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/07/02 | 富士通株式会社         | 新規作成
//================================================================================
 */
// 動作可能OSバージョン（WindowsOS）User-Agent Client Hints無効
// 「6.3」はUser-Agent Client Hints無効時のWin8.1
export const OSVER_WIN = ['6.3', '10.0'];
// 動作可能OSバージョン（WindowsOS）User-Agent Client Hints有効
export const OSVER_WIN_UACH = ['0','1','2','3','4','5','6','7','8','10'];

// 動作可能OSバージョン（MacOS）User-Agent Client Hints無効
export const OSVER_MAC = ['10_15','11'];
// 動作可能OSバージョン（MacOS）User-Agent Client Hints無効
export const OSVER_MAC_UACH = ['10.15','11'];

// 動作可能OSバージョン（AndroidOS）
export const OSVER_ANDROID = ['11','12'];
// 動作可能OSバージョン（iOS）
export const OSVER_IOS = ['13','14'];